import { ValidationErrors } from "final-form";
import React from "react";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { Modal } from "src/ui/shared/Modal/Modal";
import { makeStyles } from "tss-react/mui";

import { UploadProgressBar } from "@files/components/UploadProgressBar";
import { UploadProvider, useUploadContext } from "@files/context/UploadContext";
import { maxFileSize } from "@files/UploadPage";
import { Box, Theme } from "@mui/material";
import { UploadFileField } from "@shared/form/UploadFileField";

const useStyles = makeStyles()((theme: Theme) => ({
    dialogContent: {
        "&.MuiDialogContent-root": {
            paddingBottom: theme.spacing(2),
        },
    },
    modalTitleBox: {
        display: "flex",
        justifyContent: "space-between",
        padding: theme.spacing(2),
        paddingBottom: 0,
    },
    pointer: {
        cursor: "pointer",
    },
    contentBox: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "flex-end",
    },
}));

type FormValues = {
    files: File[];
};
type Props = {
    groupId: number;
    groupName: string;
    open: boolean;
    handleClose: React.Dispatch<React.SetStateAction<boolean>>;
};

const FileUploadContent = (props: Props) => {
    const { t } = useTranslation(["modals"]);
    const { classes } = useStyles();
    const { uploadStarted } = useUploadContext();
    const validate = (values: FormValues): ValidationErrors => {
        const errors: ValidationErrors = {};
        if (values.files) {
            for (const file of values.files) {
                if (file.size > maxFileSize) {
                    errors.files = t("modals:uploadFile.input.file.validation.maxSize", { filename: file.name });
                    break;
                }
            }
        }
        return errors;
    };

    return (
        <Modal title={t("modals:uploadFile.title")} open={props.open} onClose={() => props.handleClose(false)}>
            <Form<FormValues>
                validate={validate}
                onSubmit={() => undefined}
                render={({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <UploadFileField name="files" disabled={uploadStarted} groupId={props.groupId} uploadTargetName={props.groupName} />
                        {values?.files && values?.files.length ? (
                            <Box className={classes.contentBox}>
                                <UploadProgressBar filesToUpload={values.files} />
                            </Box>
                        ) : null}
                    </form>
                )}
            />
        </Modal>
    );
};

export const FileUploadModal = (props: Props) => (
    <UploadProvider>
        <FileUploadContent {...props} />
    </UploadProvider>
);
